<div class="grid gap-3 m-3">
  <div>
    <a mat-stroked-button routerLink="..">Back To Dashboard</a>
  </div>
  <div>
    <div class="bg-white rounded card-with-shadow px-2 pt-1">
      <mat-form-field class="w-full">
        <mat-label>Experience Types</mat-label>
        <mat-select [formControl]="experienceControl">
          <mat-option
            *ngFor="let experience of experienceTypes$ | async; trackBy: 'id' | trackByKey"
            [value]="experience"
          >
            {{ experience.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="font-bold md:text-xl p-1">Current Sand Demand Snapshots</div>
  <div class="grid grid-cols-5 bg-white p-2 card-with-shadow">
    <div class="pl-1">
      <div class="py-1 border-b-2 text-gray-700">Region</div>
      <div class="py-2 border-b-2" *ngFor="let s of (demandSnapshots$ | async)?.snapshots">{{ s.regionName }}</div>
    </div>
    <div>
      <div class="py-1 border-b-2 text-gray-700">Driver Demand</div>
      <div *ngFor="let s of (demandSnapshots$ | async)?.snapshots">
        <div *ngIf="s.driverDemand > 0" class="text-red-500 py-2 border-b-2">Driver Deficit: {{ s.driverDemand }}</div>
        <div *ngIf="s.driverDemand < 0" class="text-green-100 py-2 border-b-2">
          Driver Surplus: {{ -1 * s.driverDemand }}
        </div>
        <div *ngIf="s.driverDemand === 0" class="py-2 border-b-2">{{ s.driverDemand }}</div>
      </div>
    </div>
    <div>
      <div class="py-1 border-b-2 text-gray-700">Show Even If Unprofitable</div>
      <div class="py-2 border-b-2" *ngFor="let s of (demandSnapshots$ | async)?.snapshots">
        {{ s.showIfUnprofitable }}
      </div>
    </div>
    <div>
      <div class="py-1 border-b-2 text-gray-700">Earnings Per Shift</div>
      <div class="py-2 border-b-2" *ngFor="let s of (demandSnapshots$ | async)?.snapshots">
        {{ s.centsPerShift | currencyInPennies }}
      </div>
    </div>
    <div>
      <div class="py-1 border-b-2 text-gray-700">Expires At</div>
      <div class="py-2 border-b-2" *ngFor="let s of (demandSnapshots$ | async)?.snapshots">
        {{ s.expiresAt | standardDate }}
      </div>
    </div>
  </div>

  <div class="md:w-1/3 p-1">
    <div class="font-bold mt-3 md:text-xl mb-1">Create New Sand Demand Snapshot</div>
    <form [formGroup]="snapshotForm">
      <div class="flex items-center">
        <mat-form-field class="md:w-1/2">
          <mat-label>Regions</mat-label>
          <mat-select formControlName="regionId">
            <mat-option *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey" [value]="region.id">
              {{ region.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex items-center">
        <div *ngIf="!experienceControl.value.name" class="md:w-1/2 text-red-500">
          Please select the experience type above
        </div>
        <div class="md:w-1/2" *ngIf="experienceControl.value.name">{{ experienceControl.value.name }}</div>
      </div>
      <div class="flex items-center">
        <mat-form-field class="md:w-1/2">
          <mat-label>Demand (Driver Deficit: + / Driver Surplus -)</mat-label>
          <input matInput type="number" formControlName="driverDemand" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="flex items-center">
        <mat-form-field class="md:w-1/2">
          <mat-label>Earnings Per Shift</mat-label>
          <input matInput type="text" lohiCurrencyInput formControlName="centsPerShift" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="flex items-center">
        <mat-checkbox formControlName="showIfUnprofitable" class="md:w-1/2">Show Even If Unprofitable:</mat-checkbox>
      </div>
      <div class="flex items-center">
        <mat-form-field class="md:w-1/2">
          <mat-label>Expires At</mat-label>
          <input
            matInput
            [ngxMatDatetimePicker]="picker"
            placeholder="Choose a date"
            formControlName="dateControl"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker> </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
      <div class="mt-3 mb-2">Optional Information (For opportunities with demand)</div>
      <mat-form-field class="w-full">
        <mat-label>Title</mat-label>
        <textarea matInput placeholder="Write a title for sales pitch" formControlName="optionalTitle"></textarea>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          placeholder="Write a convincing sales pitch"
          formControlName="optionalDescription"
        ></textarea>
      </mat-form-field>
      <mat-checkbox class="md:w-1/2" [formControl]="bonusChecked">Add a per-load bonus</mat-checkbox>
      <div *ngIf="bonusChecked.value" class="flex flex-col">
        <mat-form-field class="md:w-1/2">
          <mat-label>Bonus Type</mat-label>
          <mat-select formControlName="bonusType">
            <mat-option [value]="'cents'">$ Per Load</mat-option>
            <mat-option [value]="'percent'">% Per Load</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="md:w-1/2" *ngIf="snapshotForm.value.bonusType === 'cents'">
          <mat-label>Dollar Bonus ($)</mat-label>
          <input matInput type="text" lohiCurrencyInput formControlName="bonusQuantity" autocomplete="off" />
        </mat-form-field>
        <mat-form-field class="md:w-1/2" *ngIf="snapshotForm.value.bonusType === 'percent'">
          <mat-label>Percent Bonus (%)</mat-label>
          <input matInput type="number" formControlName="bonusQuantity" autocomplete="off" />
        </mat-form-field>
        <mat-form-field class="md:w-1/2">
          <mat-label>Bonus Expires At</mat-label>
          <input
            matInput
            [ngxMatDatetimePicker]="bonusPicker"
            placeholder="Choose a date"
            formControlName="bonusExpiresAt"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="bonusPicker"> </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #bonusPicker> </ngx-mat-datetime-picker>
        </mat-form-field>
        <div>
          (Bonus applies to loads dispatched before this time, to users who transfer to this region from another)
        </div>
        <mat-form-field class="md:w-1/2">
          <mat-label>Max $ Per Driver</mat-label>
          <input matInput lohiCurrencyInput formControlName="maxCentsPerUser" autocomplete="off" />
        </mat-form-field>
      </div>
    </form>
    <div class="mt-2">Creating a demand opportunity will automatically send SMS messages to account admins.</div>
    <div class="mt-2">
      <button mat-raised-button class="w-full" (click)="createNewSnapshot()">Create New Sand Snapshot</button>
    </div>
  </div>
</div>
